import { combineReducers } from 'redux';
import stockStoreReducer from './stock-store';

export default combineReducers({
  store: stockStoreReducer,
});
